var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"has-text-centered has-text-grey-light",class:_vm.padding},[_c('p',{staticClass:"py-md"},[_c('b-icon',{attrs:{"icon":"loading","custom-class":"mdi-spin","size":_vm.size}})],1),_c('p',[_vm._v(_vm._s(_vm.message))])])}
var staticRenderFns = []

export { render, staticRenderFns }